import GerenciadorNFCeService from "@/services/GerenciadorNFCeService";

export const gerenciadorNFCe = {
  namespaced: true,
  state: {
    gerenciadorNFCe: {},
  },
  actions: {
    consultarStatusServico({ commit }, payload) {
      return GerenciadorNFCeService.ConsultarStatusServico(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    consultarStatusNFCe({ commit }, payload) {
      return GerenciadorNFCeService.ConsultarStatusNFCe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    transmitirNFCe({ commit }, payload) {
      return GerenciadorNFCeService.TransmitirNFCe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    imprimirVenda({ commit }, payload) {
      return GerenciadorNFCeService.ImprimirVenda(payload).then(
        (vendasCupom) => {
          return Promise.resolve(vendasCupom);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    downloadXMLNFCe({ commit }, payload) {
      return GerenciadorNFCeService.DownloadXMLNFCe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    cancelarVenda({ commit }, payload) {
      return GerenciadorNFCeService.CancelarVenda(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    inutilizarNFCe({ commit }, payload) {
      return GerenciadorNFCeService.InutilizarNFCe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    entrarContingenciaNFCe({ commit }, payload) {
      return GerenciadorNFCeService.EntrarContingenciaNFCe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default gerenciadorNFCe;
